<script>
	import model from "../../stores/modelStore";

	import confirmationPages from "./confirmationPages";
	import { projectSettings } from "../../config";

	import FormRowColumn from "../../components/FormRowColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";

	import Consents from "./components/Consents.svelte";

	let disabled = true;

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<FormRowColumn>
		<h1 class="text-center">{@html projectSettings.classActionName}</h1>
	</FormRowColumn>

	<div class="confirmation">
		{#each confirmationPages as page}
			{#if (typeof page.hidePage === "function" && !page.hidePage($model)) || !page.hidePage}
				<ReviewSectionHeader heading={page.confirmationHeading}></ReviewSectionHeader>

				<svelte:component this={page.component} {...page} {disabled} />
			{/if}
		{/each}
	</div>

	<Consents bind:model={$model} disabled={true} />
</section>
